import { Service } from "typedi";
import { IApplePaySession } from "../../models/IApplePaySession";
import { RequestJwtUpdateHandler } from "../../../../../application/core/services/st-codec/RequestJwtUpdateHandler";
import { IApplePayPaymentDataCallBacks } from "../../../models/IApplePayPaymentDataCallbacks";
import { ApplePayShippingContactResolver } from "./ApplePayShippingContactResolver";

/**
 * Represents the binding action for ApplePay's onShippingContactSelected callback.
 *
 * Here, we offer the ability for merchants to specify a way to resolve the callback
 * and/or update the JWT for the run.
 */
@Service()
export class ApplePayShippingContactAction {
  constructor(private jwtRequestHandler: RequestJwtUpdateHandler) {}

  public execute(
    session: IApplePaySession,
    version: number,
    data: ApplePayJS.ApplePayShippingContactSelectedEvent,
    callbacks: IApplePayPaymentDataCallBacks | undefined,
  ): void {
    if (!callbacks || !callbacks.onShippingContactSelected) {
      // No need to do anything if there is no callback specified by the merchant.
      return;
    }

    const actions = new ApplePayShippingContactResolver(
      session,
      version,
      this.jwtRequestHandler,
    );
    callbacks.onShippingContactSelected(data, actions);
  }
}
